import { MaxbrainImage } from 'app/library/image-library/models/maxbrain-image.model';
import { ICourseExecutionProgramExecutionQuery } from '../interfaces/course-execution-program-execution.query.interface';
import { RelevantExecutionRuleEnum } from '../enums/relevant-execution-rule.enum';

export class CourseExecutionProgramExecution {
    id: string;
    name: string;
    startDate: Date | null;
    endDate: Date | null;
    status: string;
    isDefault: boolean;
    relevantExecutionRule: RelevantExecutionRuleEnum;
    selfPaced: boolean;
    image: MaxbrainImage | null;
    courseOffering: {
        id: string;
        name: string;
    } | null;
    category: {
        id: string;
        name: string;
    } | null;
    canToggleDefault: boolean;
    canRemove: boolean;
    hasActions: boolean;
    isSelected?: boolean;

    constructor(query: ICourseExecutionProgramExecutionQuery) {
        this.id = query.id.toString();
        this.name = query.name;
        this.startDate = query.start_date;
        this.endDate = query.end_date;
        this.status = query.status;
        this.isDefault = !!query.is_default;
        this.relevantExecutionRule = query.relevant_execution_rule;
        this.canToggleDefault = this.relevantExecutionRule !== RelevantExecutionRuleEnum.AUTO_ADD_ALL_EXECUTIONS_WITH_AUTO_DEFAULT;
        this.canRemove = this.relevantExecutionRule === RelevantExecutionRuleEnum.MANUALLY_ADD_EXECUTIONS;
        this.hasActions = this.canToggleDefault || this.canRemove;
        this.selfPaced = !!query.self_paced;
        this.image = query.image ? new MaxbrainImage(query.image) : null;
        this.courseOffering = query.course_offering
            ? {
                  id: query.course_offering.id.toString(),
                  name: query.course_offering.name,
              }
            : null;
        this.category = query.category
            ? {
                  id: query.category.id.toString(),
                  name: query.category.name,
              }
            : null;
    }

    get offeringSubtitle(): string {
        if (this.category?.name && this.courseOffering?.name) {
            return `${this.category.name} / ${this.courseOffering.name}`;
        }

        return this.courseOffering?.name || '';
    }
}
